export const crToLocale = {
  'de-DE': 'de',
  'ru-RU': 'ru',
  'it-IT': 'it',
  'ar-SA': 'ar',
  'fr-FR': 'fr',
  'pt-PT': 'pt-br',
  'pt-BR': 'pt-br',
  'es-ES': 'es-es',
  'es-419': 'es',
  'en-US': 'en',
  'hi-IN': 'hi',
  'id-ID': 'id',
  'th-TH': 'th',
  'zh-TW': 'tw',
  'pl-PL': 'pl',
}

export const localeToCr = {
  de: 'de-DE',
  ru: 'ru-RU',
  it: 'it-IT',
  ar: 'ar-SA',
  fr: 'fr-FR',
  'pt-pt': 'pt-PT',
  'pt-br': 'pt-BR',
  'es-es': 'es-ES',
  es: 'es-419',
  en: 'en-US',
  hi: 'hi-IN',
  id: 'id-ID',
  th: 'th-TH',
  tw: 'zh-TW',
  pl: 'pl-PL',
}

export const localeToBraze = {
  ja: 'ja',
  ru: 'ru',
  it: 'it',
  ar: 'ar',
  de: 'de',
  fr: 'fr',
  'pt-pt': 'pt',
  'pt-br': 'pt',
  'es-es': 'es',
  es: 'es',
  en: 'en',
  hi: 'hi',
  id: 'id',
  th: 'th',
  tw: 'tw',
  pl: 'pl',
}

export const crLangList = [
  'ar',
  'de',
  'en',
  'es',
  'es-es',
  'fr',
  'hi',
  'id',
  'it',
  'pt-br',
  'pt-pt',
  'ru',
  'th',
  'tw',
  'pl',
]
